import Vue from 'vue'

import OrbcommLastUpdated from '@/components/Plugins/OrbcommLastUpdated'
Vue.component('OrbcommLastUpdated', OrbcommLastUpdated)
